(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ave-link-demo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ave-link-demo-player')) {
  customElements.define('ave-link-demo-player', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        button.hidden = true;
        video.focus();
        const playback = video.play();
        if (playback) playback.catch(() => { button.hidden = false; });
      });
      video.addEventListener('play', () => { button.hidden = true; });
      video.addEventListener('ended', () => { button.hidden = false; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
